import { apiCall } from "../../../utils/api.utils";
import { API_URLS } from "../../../constants/apiUrls";

export const userService = {
   getAllUsers,
  postUser,
  toggleUser,
  getUserRole,
  changeRole,
  getUser,
  updateUser
};

function getAllUsers(params) {
  let url = API_URLS.USERS.GET_USERS;
  return apiCall(
    "GET",
    url,
    null,
    null,
    params
  );
}

function postUser(request, id) {
  
  const method = id ? "PUT" : "POST";
  
  return apiCall(method, API_URLS.USERS.POST_USER_ADMIN, null, request);
}

function updateUser(request, id) {
  
  const method = id ? "PUT" : "POST";
  
  return apiCall(method, API_URLS.USERS.UPDATE_USER_ADMIN, null, request);
}

function getUser(params) {
  
  return apiCall("GET", API_URLS.USERS.GET_USER,null,null,params);
}

function toggleUser(username, active) {
  return apiCall(
    "PUT",
    `${
      active ? API_URLS.USERS.DISABLE_USER : API_URLS.USERS.ENABLE_USER
    }`,
    null,null,{username:username}
  );
}

function getUserRole(username) {
  return apiCall("GET", `${API_URLS.USERS.GET_USER_ROLE}`, null, null, {
    username
  });
}

function changeRole(requestBody, userToEdit) {

  return apiCall(
    "PUT",
    `${API_URLS.USERS.GET_USER_ROLE}/${userToEdit.id}`,
    null,
    requestBody
  );
}
